import React from 'react';
import { Modal } from 'antd';
import UserPageEditUser from './edit_form';

const UserPageEditModal = ({ dn, userPageopen, userPageData, setUserPageopen }) => {
  const handleCancel = () => {
    setUserPageopen(false);
  };

  return (
    <Modal
      open={userPageopen}
      maskClosable={false}
      onCancel={handleCancel}
      footer={false}
      centered
      width={800}
      className='modal-style af-updateuser-single-modal'
    >
      <UserPageEditUser dn={dn} userPageData={userPageData} handleCancel={handleCancel} />
    </Modal>
  );
};

export default UserPageEditModal;
